<td matTooltipPosition="above" [matTooltip]="activities">
  <i *ngFor="let icon of heatIcons" class="fa-pepper-hot" [ngClass]="{'fal': !icon.filled, 'fas': icon.filled}" [ngStyle]="{'color': icon.filled ? heatColors[numberOfSolidIcons] : '' }">
  </i>
</td>
